import { categories } from "@/mocks/guaContent";

export default function Channels() {
  return (
    <section id="channels" className="relative bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-sm font-semibold text-primary-600 tracking-wide">CHANNELS · 频道栏目</p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-900">
              六大频道，你想先吃哪块瓜
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600 leading-relaxed">
            每条推送都按你订阅的频道定制，把关注度都留给真正想看的板块，减少无关信息打扰。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((c) => (
            <article
              key={c.name}
              className="group rounded-lg bg-background-50 border border-background-200 p-6 transition duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-2xl">
                  <i className={c.icon}></i>
                </span>
                <span className="text-xs rounded-full bg-secondary-100 text-secondary-800 px-2.5 py-1 whitespace-nowrap">
                  {c.count}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-900">{c.name}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              <a
                href="#plans"
                className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition"
              >
                订阅该频道 <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}